'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { RERAN_VARIATION } from '../actions/ActionTypes';
import { receiveVariations, requestedRerunVariationFailure, requestedRerunVariationSuccess, requestedVariationsFailed, requestRerunVariation, requestVariations } from '../actions/VariationsActions';
export default ((action$, _, {
  VariationsClient
}) => action$.ofType(RERAN_VARIATION).pipe(mergeMap(({
  payload: {
    abTestId,
    contentType,
    variationId
  }
}) => VariationsClient.rerun(abTestId, contentType, variationId).pipe(mergeMap(() => VariationsClient.fetch(abTestId, contentType).pipe(mergeMap(variations => of(receiveVariations(variations), requestedRerunVariationSuccess(contentType))), catchError(error => of(requestedVariationsFailed(error))), startWith(requestVariations()))), catchError(error => of(requestedRerunVariationFailure(error, contentType))), startWith(requestRerunVariation())))));